import React from "react";
import classNames from "classnames";
import { CardFrame } from "./CardFrame";
import { ProfileModal } from "./ProfileModal";
import { ProfileImage } from "./ProfileImage";
import { ImageData } from "~/models/image";

export const ProfileCard = ({
  name,
  image,
  title,
  bio,
}: {
  name: string;
  image?: Record<string, ImageData>;
  title: string;
  bio: string;
}) => {
  const [showModal, setShowModal] = React.useState(false);
  const imageUrl = image && image["large"] ? image["large"].url : "";

  return (
    <div id="cn-profile-modal" className="tw:w-full">
      <ProfileModal
        name={name}
        title={title}
        bio={bio}
        imageUrl={imageUrl}
        show={showModal}
        onClose={() => setShowModal(false)}
      />

      <div
        className="tw:flex tw:flex-row tw:justify-center tw:w-full"
        onClick={() => setShowModal(true)}
      >
        <CardFrame className={classNames("tw:h-full tw:max-w-[400px]")}>
          <div className="tw:flex tw:flex-row tw:justify-center tw:items-center tw:mt-[-21px]">
            <ProfileImage title={title} imageUrl={imageUrl} />
          </div>

          <div
            className={classNames(
              "tw:flex tw:flex-col tw:justify-start tw:gap-4 tw:px-6 tw:py-4 tw:w-full",
              "tw:justify-center tw:h-full",
            )}
          >
            <div
              className={classNames(
                "tw:tracking-tight tw:font-[600]",
                "tw:text-[1.5rem]",
                "tw:w-full",
              )}
            >
              <div dangerouslySetInnerHTML={{ __html: name ?? "" }} />
            </div>
            <div className="tw:font-[400] tw:text-base tw:leading-normal tw:max-w-[352px] tw:min-h-[72px] tw:max-h-[72px]">
              <div dangerouslySetInnerHTML={{ __html: title ?? "" }} />
            </div>
          </div>
        </CardFrame>
      </div>
    </div>
  );
};
